module.exports = __webpack_public_path__ + "static/media/member (3).803a4f28.png";